import { backendBaseUrl, socialBaseUrl } from "@/shared/lib/platform"
import { client as backendClient } from "../generated-backend/client.gen"
import { client as socialClient } from "../generated-social/client.gen"
import { networkAwareFetch } from "./fetch"
import {
	platform,
	prepareRequest,
	refreshOnUnauthorized,
	reportContractMismatch,
	store,
	throwOnErrorStatus,
} from "./requests"
import { resolveAccessToken } from "./tokens"

export { HttpError } from "../errors"
export { deadlineFetch } from "./fetch"
export { authorizedFetch } from "./requests"
export {
	getFreshRefreshToken,
	resolveAccessToken as getValidAccessToken,
} from "./tokens"

for (const [client, baseUrl] of [
	[backendClient, backendBaseUrl],
	[socialClient, socialBaseUrl],
] as const) {
	client.setConfig({
		baseUrl,
		headers: {
			Accept: "application/json",
			"X-Platform": platform,
			"X-Store": store,
		},
		auth: resolveAccessToken,
		fetch: networkAwareFetch,
	})
	client.interceptors.request.use(prepareRequest)
	client.interceptors.response.use(refreshOnUnauthorized)
	client.interceptors.response.use(throwOnErrorStatus)
	client.interceptors.error.use(reportContractMismatch)
}
